import { ref, onMounted } from 'vue';
import abonosService from '@/services/perfil/abonos';

/**
 * useListasAbonados — fetches available subscriber lists for the profile filter.
 *
 * Shared composable used by both useAbonos and useCantera to power the
 * "lista de abonados" single-select filter.
 *
 * @returns {{
 *   listas: import('vue').Ref<Array>,
 *   listasLoading: import('vue').Ref<boolean>,
 *   selectedListaId: import('vue').Ref<number|string|null>,
 *   onListaFilterChange: (id: number|string|null) => void,
 * }}
 */
export function useListasAbonados({ onFilterChange } = {}) {
    const listas = ref([]);
    const listasLoading = ref(false);
    const selectedListaId = ref(null);

    const fetchListas = async() => {
        listasLoading.value = true;
        try {
            listas.value = await abonosService.getListasAbonados();
        } catch (err) {
            if (process.env.NODE_ENV !== 'production') {
                console.error('[useListasAbonados] Error al obtener listas de abonados:', err);
            }
            listas.value = [];
        } finally {
            listasLoading.value = false;
        }
    };

    const onListaFilterChange = id => {
        selectedListaId.value = id || null;
        if (onFilterChange) {
            onFilterChange(selectedListaId.value);
        }
    };

    onMounted(() => {
        fetchListas();
    });

    return {
        listas,
        listasLoading,
        selectedListaId,
        fetchListas,
        onListaFilterChange,
    };
}
